import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createRole } from '@/api/access/accessApi';
import type { CreateRolePayload, RoleDetail } from '@/api/access/accessApi.types';
import { ROLES_QUERY_KEY } from '@/constants/queryKeys';

export function useCreateRoleMutation(): UseMutationResult<RoleDetail, Error, CreateRolePayload> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRole,
    onSuccess: function invalidateRoles() {
      queryClient.invalidateQueries({ queryKey: ROLES_QUERY_KEY });
    },
  });
}
